export const supportedLocales = [
  'bg-BG',
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-BE',
  'de-CH',
  'de-DE',
  'de-LU',
  'el-GR',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IE',
  'en-US',
  'es-ES',
  'et-EE',
  'fi-FI',
  'fi-SE',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-FR',
  'fr-LU',
  'hr-HR',
  'hu-HU',
  'is-IS',
  'it-CH',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'lt-LT',
  'lv-LV',
  'ms-MY',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'nn-NO',
  'no-NO',
  'pl-PL',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sl-SI',
  'sr-RS',
  'sv-FI',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'vi-VN',
  'zh-CN',
];
